import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import apiClient, { setAccessToken } from '../utils/api';
import { useAuth } from '../contexts/AuthContext';
import './AdminSignupPage.css';

export default function AdminSignupPage() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') || '';
  useAuth();   // ensures we're inside the provider

  const [fullName, setFullName] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!token) {
      setError('Missing invitation token. Please use the link from your email.');
      return;
    }
    if (password !== confirmPassword) {
      setError('Passwords do not match.');
      return;
    }
    if (password.length < 8) {
      setError('Password must be at least 8 characters.');
      return;
    }

    setBusy(true);
    try {
      const { data } = await apiClient.post('/auth/register-admin', {
        invitation_token: token,
        password,
        confirm_password: confirmPassword,
        full_name: fullName,
      });
      // Auto-login: store the access token then redirect
      setAccessToken(data.access_token);
      // Force a silent refresh so AuthContext picks up the new user + cookie
      window.location.href = '/';
    } catch (err) {
      const detail = err.response?.data?.detail;
      if (Array.isArray(detail)) {
        setError(detail.map((d) => d.msg || JSON.stringify(d)).join('. '));
      } else if (typeof detail === 'string') {
        setError(detail);
      } else {
        setError(err.message || 'Registration failed.');
      }
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="admin-login-page">
      <div className="admin-login-card">
        <div className="admin-login-header">
          <h1>🏗 Accept Invitation</h1>
          <p>Set up your account to get started</p>
        </div>

        {error && <div className="admin-login-error">{error}</div>}

        <form onSubmit={handleSubmit} className="admin-login-form">
            <label>
              Full Name
              <input
                type="text"
                value={fullName}
                onChange={(e) => setFullName(e.target.value)}
                required
                autoFocus
                placeholder="Your full name"
                minLength={2}
              />
            </label>
            <label>
              Password
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                placeholder="Min 8 chars, 1 uppercase, 1 digit"
                minLength={8}
              />
            </label>
            <label>
              Confirm Password
              <input
                type="password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
                placeholder="Re-enter password"
                minLength={8}
              />
            </label>
            <button type="submit" className="admin-login-btn" disabled={busy}>
              {busy ? 'Creating account…' : 'Create Account'}
            </button>
          </form>

        <p className="admin-login-note">
          Already have an account? <a href="/login">Sign in</a>
        </p>
      </div>
    </div>
  );
}
